const $ = jQuery;

const cSPrefillCalculatorResultsContent = (campaign) => {
  let field_map = [
    {
      type: "input",
      fieldName: "form-field-name",
      sourceValue: "campaign.name",
    },
		{
			type: "daterange",
			data: {
				startValue: campaign.start_date,
				endValue: campaign.end_date,
			},
			fieldName: "date-range-dynamic-input",
			sourceValue: "campaign.start_date",
		},
    {
      type: "input",
      fieldName: "form-field-followers",
      sourceValue: "campaign.followers",
    },
    {
      type: "checkbox",
      checkCondition: true,
      fieldNameWhenTrue: "form-field-is_pro-0",
      fieldNameWhenFalse: "form-field-is_pro-1",
      sourceValue: "campaign.isPro",
    },
    {
      type: "input",
      fieldName: "form-field-image_num",
      sourceValue: "campaign.imageNum",
    },
    {
      type: "input",
      fieldName: "form-field-video_num",
      sourceValue: "campaign.shortVideoNum",
    },
    {
      type: "input",
      fieldName: "form-field-content_months",
      sourceValue: "campaign.organicSocialMonths",
    },
    {
      type: "checkbox",
      checkCondition: 1,
      fieldNameWhenTrue: "form-field-website_co-0",
      fieldNameWhenFalse: "form-field-website_co-1",
      sourceValue: "campaign.organicSiteMonths",
    },
    {
      type: "checkbox",
      checkCondition: 1,
      fieldNameWhenTrue: "form-field-paid_social_co-0",
      fieldNameWhenFalse: "form-field-paid_social_co-1",
      sourceValue: "campaign.paidSocialMonths",
    },
    {
      type: "checkbox",
      checkCondition: 1,
      fieldNameWhenTrue: "form-field-digital_media_co-0",
      fieldNameWhenFalse: "form-field-digital_media_co-1",
      sourceValue: "campaign.digitalMediaMonths",
    },
    {
      type: "checkbox",
      checkCondition: 1,
      fieldNameWhenTrue: "form-field-ooh_co-0",
      fieldNameWhenFalse: "form-field-ooh_co-1",
      sourceValue: "campaign.oohMonths",
    },

    {
      type: "checkbox",
      checkCondition: 1,
      fieldNameWhenTrue: "form-field-full_ip_co-0",
      fieldNameWhenFalse: "form-field-full_ip_co-1",
      sourceValue: "campaign.fullIPMonths",
    },
    {
      type: "input",
      fieldName: "form-field-broadcast_months",
      sourceValue: "campaign.broadcastMonths",
    },

    {
      type: "input",
      fieldName: "form-field-pocket",
      sourceValue: "campaign.pocketInput",
    },
    {
      type: "checkbox",
      checkCondition: CONTOPTIN_DISCOUNT,
      fieldNameWhenTrue: "form-field-opt_in-0",
      fieldNameWhenFalse: "form-field-opt_in-1",
      sourceValue: "campaign.optIn",
    },
  ];

  field_map.forEach((element) => {
    const [objectName, key] = element.sourceValue.split(".");
    const dataObject = eval(objectName);
    const dataValue = dataObject[key];
    switch (element.type) {
      case "checkbox":
        if ("object" == typeof element.checkCondition) {
          // loop on conditions and check the correct one
          element.checkCondition.forEach((checkConditionItem) => {
            if ($("#" + checkConditionItem.fieldWhenConditionMet).length) {
              if (dataValue == checkConditionItem.condition) {
                $("#" + checkConditionItem.fieldWhenConditionMet).prop(
                  "checked",
                  true
                );
              }
            }
          });
        } else {
          // default checkbox true or false only
          if (dataValue == element.checkCondition) {
            if ($("#" + element.fieldNameWhenTrue).length) {
              $("#" + element.fieldNameWhenTrue).prop("checked", true);
            }
          } else {
            if ($("#" + element.fieldNameWhenFalse).length) {
              $("#" + element.fieldNameWhenFalse).prop("checked", true);
            }
          }
        }
        break;
      case "daterange":
        csUpdateDateRangePickers(element.data.startValue, element.data.endValue);
      case "input":
      default:
        if ($("#" + element.fieldName).length) {
          document.getElementById(element.fieldName).value = dataValue;
          break;
        }
    }
  });

  // document.getElementById("form-field-name").value = campaign.name;
  // document.getElementById("form-field-followers").value = campaign.followers;
  // if (campaign.isPro === true) {
  // 	document.getElementById("form-field-is_pro-0").checked = true;
  // } else {
  // 	document.getElementById("form-field-is_pro-1").checked = true;
  // }
  // document.getElementById("form-field-image_num").value = campaign.imageNum;
  // document.getElementById("form-field-video_num").value =
  // 	campaign.shortVideoNum;
  // document.getElementById("form-field-organic_social_months").value =
  // 	campaign.organicSocialMonths;
  // document.getElementById("form-field-organic_site_months").value =
  // 	campaign.organicSiteMonths;
  // document.getElementById("form-field-paid_social_months").value =
  // 	campaign.paidSocialMonths;
  // document.getElementById("form-field-digital_media_months").value =
  // 	campaign.digitalMediaMonths;
  // document.getElementById("form-field-ooh_months").value = campaign.oohMonths;
  // document.getElementById("form-field-broadcast_months").value =
  // 	campaign.broadcastMonths;
  // document.getElementById("form-field-full_ip_months").value =
  // 	campaign.fullIPMonths;
  // document.getElementById("form-field-pocket").value = campaign.pocketInput;
  // if (campaign.optIn === CONTOPTIN_DISCOUNT) {
  // 	document.getElementById("form-field-opt_in-0").checked = true;
  // } else {
  // 	document.getElementById("form-field-opt_in-1").checked = true;
  // }
};
export default cSPrefillCalculatorResultsContent;
